// extracted by mini-css-extract-plugin
module.exports = {"root":"Navbar_root__JXKn9","link":"Navbar_link__IStfC","logo":"Navbar_logo__gEyoC"};